module.exports = __webpack_public_path__ + "img/user.152de8b5.png";